import classnames from 'classnames';
import React from 'react';

import { TypeOfChange } from '../getTypeOfChangeByChangeCodeAndTypeOfThing';

const mapTypeOfChangeToClassNames: Record<TypeOfChange, string> = {
  ADDITION: 'bg-success border-success text-success',
  DEPRECATION: 'bg-warning border-warning text-warning',
  REMOVAL: 'bg-error border-error text-error',
  SOMETHING_INSIDE_THIS_CHANGED: 'border-transparent',
  THIS_CHANGED: 'bg-warning border-warning text-warning',
};

export const ChangeHighlighter = ({
  typeOfChange,
  className,
  children,
  size = 'standard',
}: {
  typeOfChange: TypeOfChange | null;
  className?: string;
  children: React.ReactNode;
  size?: 'small' | 'standard';
}) => {
  return (
    <span
      className={classnames(
        className,
        'inline-block rounded border',
        typeOfChange &&
          classnames(
            'px-2',
            // eslint-disable-next-line local/no-conditional-class-names
            mapTypeOfChangeToClassNames[typeOfChange],
          ),
        !typeOfChange && 'border-transparent',
        size === 'small'
          ? 'py-0.5 font-mono text-sm leading-tight'
          : 'font-mono text-base',
      )}
    >
      {children}
    </span>
  );
};
